import { MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { SERVICE_AREAS } from "@/site";

export const ServiceArea = () => (
    <section id="service-area" data-testid="service-area-section" className="bg-slate-50 py-20 sm:py-24 lg:py-28">
        <div className="mx-auto grid w-full max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
            <div>
                <SectionHead
                    eyebrow="Local & Nearby"
                    title="Your Local Locksmith, When You Need Us"
                    text="We provide locksmith services for homeowners, businesses, and vehicle owners throughout the local area. Whether it's a planned security upgrade or an unexpected lockout, our goal is to provide dependable service when you need it."
                    testId="service-area-heading"
                />
                <Reveal delay={0.2}>
                    <p className="mt-8 text-xs font-bold uppercase tracking-[0.22em] text-slate-500">
                        Communities We Serve
                    </p>
                    <ul data-testid="service-area-list" className="mt-4 flex flex-wrap gap-2.5">
                        {SERVICE_AREAS.map((area) => (
                            <li
                                key={area}
                                className="inline-flex items-center gap-1.5 rounded-full border border-navy-950/15 bg-white px-4 py-2 text-sm font-semibold text-navy-950"
                            >
                                <MapPin className="h-3.5 w-3.5 text-gold-dark" />
                                {area}, SK
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
            <Reveal delay={0.15}>
                <div
                    data-testid="service-area-map"
                    className="overflow-hidden rounded-3xl border border-slate-200 shadow-xl shadow-navy-950/10"
                >
                    <iframe
                        title="Service area map — Regina, Saskatchewan"
                        src="https://www.google.com/maps?q=Regina,+Saskatchewan&z=10&output=embed"
                        loading="lazy"
                        className="h-80 w-full border-0 sm:h-[420px]"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </Reveal>
        </div>
    </section>
);
